import { apiSlice } from "../api/apiSlice";

export const quizMarksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizMarks: builder.query({
      query: () => "/quizMark",
    }),
    getQuizMark: builder.query({
      query: (id) => `/quizMark/${id}`,
    }),
    addQuizMark: builder.mutation({
      query: (data) => ({
        url: "/quizMark",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const quizMark = await queryFulfilled;
          // add quiz mark cache pessimistically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getQuizMarks",
              undefined,
              (draft) => {
                draft.push(quizMark?.data);
              }
            )
          );
          // add quiz mark cache pessimistically end
        } catch (err) {}
      },
    }),
    updateQuizMark: builder.mutation({
      query: ({ id, data }) => ({
        url: `/quizMark/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const quizMark = await queryFulfilled;
          // add quiz mark cache pessimistically start
          dispatch(
            apiSlice.util.updateQueryData(
              "getQuizMarks",
              undefined,
              (draft) => {
                const indexToUpdate = draft.find((q) => q.id == arg.id);
                indexToUpdate.mark = quizMark?.data?.mark;
                indexToUpdate.status = quizMark?.data?.status;
              }
            )
          );
          // add quiz mark cache pessimistically end
        } catch (err) {}
      },
    }),
    deleteQuizMark: builder.mutation({
      query: (id) => ({
        url: `/quizMark/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getQuizMarks", undefined, (draft) => {
            const indexToRemove = draft.findIndex((q) => q.id === arg);
            if (indexToRemove !== -1) {
              draft.splice(indexToRemove, 1);
            }
          })
        );
        // optimistic cache update end

        try {
          await queryFulfilled;
        } catch (err) {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetQuizMarksQuery,
  useGetQuizMarkQuery,
  useAddQuizMarkMutation,
  useUpdateQuizMarkMutation,
  useDeleteQuizMarkMutation,
} = quizMarksApi;
